import { connect } from "react-redux";
import { Transition } from "@headlessui/react";
import { IconX } from "@tabler/icons-react";

function getDaisyAlertClass(type) {
  switch (type) {
    case "success":
      return "alert-success";
    case "error":
      return "alert-error";
    case "warning":
      return "alert-warning";
    default:
      return "alert-info";
  }
}

function getAlertIcon(type) {
  switch (type) {
    case "success":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 shrink-0 stroke-current"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    case "error":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 shrink-0 stroke-current"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 
               2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 
               0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      );
    case "warning":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 shrink-0 stroke-current"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M4.93 
               19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 
               5c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 
               1.33.19 3 1.73 3z"
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 shrink-0 stroke-current"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 
               12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
  }
}

function Alerts({ alerts, removeAlert }) {
  return (
    // Ajustamos la posición para que en pantallas pequeñas sea top-2 right-2
    // y en pantallas medianas+ sea top-5 right-5
    <div className="fixed top-2 right-2 sm:top-5 sm:right-5 z-50 
                    flex flex-col items-end space-y-2 
                    w-auto max-w-[90%] sm:max-w-md">
      {alerts.map((alert) => (
        <Transition
          key={alert.id}
          show
          enter="transition-transform ease-out duration-300"
          enterFrom="translate-x-full opacity-0"
          enterTo="translate-x-0 opacity-100"
          leave="transition-transform ease-in duration-200"
          leaveFrom="translate-x-0 opacity-100"
          leaveTo="translate-x-full opacity-0"
        >
          <div
            role="alert"
            className={`alert flex items-center justify-between px-4 py-2 rounded-lg shadow-lg ${getDaisyAlertClass(alert.alertType)}`}
          >
            <div className="flex items-center gap-2">
              {getAlertIcon(alert.alertType)}
              <span className="text-sm">{alert.msg}</span>
            </div>
            <button
              onClick={() => removeAlert(alert.id)}
              type="button"
              className="btn btn-ghost p-1"
            >
              <IconX className="h-5 w-5" />
            </button>
          </div>
        </Transition>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.Alert.alerts,
});

const mapDispatchToProps = (dispatch) => ({
  removeAlert: (id) => dispatch({ type: "REMOVE_ALERT", payload: id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
